import classNames from 'classnames';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import type { TopTradesItemProps } from './TopTradesItem';

const ContentParagraph = styled.p`
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const MainTopTradesItem: FC<TopTradesItemProps> = ({ title, content, documentLink, className }) => (
  <div className={classNames('card col-12 mx-0 ps-0 pb-3 mb-3 border-bottom', className)} data-e2e="top-trades-item">
    <div className="card-body col col-md-8 px-0 py-0">
      <h5 className="text-primary" data-e2e="main-top-trades-title">
        <span>{title}</span>
        {documentLink && (
          <a href={documentLink} target="_blank">
            <i className="icon icon-sm ms-4">insert_drive_file</i>
          </a>
        )}
      </h5>
      {content && (
        <ContentParagraph
          className="card-text mt-2 mb-0"
          data-e2e="sgnews-item-description"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  </div>
);

export const MainTopTradesItemSkeleton: FC<{ className?: string; lines: number }> = ({ className, lines }) => (
  <div className={classNames('card col-12 mx-0 ps-0 pb-3 mb-3 border-bottom', className)} data-e2e="top-trades-item">
    <div className="card-body col col-md-8 px-0 py-0">
      <h5 className="text-primary" data-e2e="main-top-trades-title">
        <Skeleton width="15em" />
      </h5>
      <ContentParagraph className="card-text mt-2 mb-0">
        <Skeleton count={lines} />
      </ContentParagraph>
    </div>
  </div>
);
